<template>
    <div class="fooret_box">
        <!-- 底部 -->
        <div class="bottom_bxo">
            <div class="b_yonghu">
            <p class="b_p1">
                <span class="wu_tiao" @click="Fwtk()">{{$t('foorter.FWTK')}}</span>
                <span class="wu_tiao" @click="Kfzx()">{{$t('foorter.YSZC')}}</span>
                <span class="wu_tiao" @click="Zxzh()">{{$t('foorter.ZX')}}</span>
            </p>
            <p class="b_p2">
                <span>{{$t('foorter.p1')}}</span>
            </p>
            <p class="b_p2">
                <span>{{$t('foorter.p2')}}</span>
            </p>
            <p class="b_p3">
                <span>{{$t('foorter.gsmc')}}</span>&nbsp;
                <span>{{$t('foorter.gsdz')}}</span>
            </p>
            </div>
        </div>
    </div>
</template>
<script>
    export default{
        data(){
            return{}
        },
        methods:{
            //底部跳转的链接
            Fwtk(){//服务条款
                if(this.$store.state.EnZh==true){
                this.$router.push('/en_fwtk');//英文
                }else{
                this.$router.push('/fwtk');//中文
                }
            },
            Kfzx(){//隐私政策
                if(this.$store.state.EnZh==true){
                this.$router.push('/en_yszc');//英文
                }else{
                this.$router.push('/yszc');//中文
                }
            },

            //注销账号
            Zxzh(){
              this.$router.push('/zhuxiao');//中文
            }
        }
    }
</script>
<style lang="scss" scoped>
  .fooret_box{
    width: 100%;
  }
//底部
.bottom_bxo{
      width: 100%;
      height: 160px;
      background-color: #101010;
      display: flex;
      align-items: center;
      justify-content: center;
      .b_left_logn{
        width: 260px;
        display: flex;
        justify-content: center;
        align-items: center;
        margin-right: 50px;
        img{
          width: 170px;
        }
      }
      .b_yonghu{
        width: 60%;
        display: flex;
        flex-direction: column;
        align-items: center;
        .b_p1{
          font-size: 15px;
          padding: 15px 0;
          display: flex;
          align-items: center;
          .wu_tiao{
            margin-right: 15px;
            border-right: 1px solid #8d8d8d;
            padding-right: 15px;
            height: 15px;
            line-height: 15px;
            color: #e3e3e3;
          }
          
          .wu_tiao:nth-child(3){
            border-right: none;
          }
        }
        .b_p2{
          font-size: 13px;
          color: #b0b0b0;
          display: flex;
          align-items: center;
          flex-wrap: wrap;
          padding: 3px 0;
          text-align: center;
          span{
            margin-right: 12px;
          }
        }
        .b_p3{
          font-size: 13px;
          color: #b0b0b0;
          padding: 3px 0;
          text-align: center;
          span{
            margin-right: 12px;
          }
        }
      }
    }
</style>